import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as actions from "../../../../actions/mainTabActions";
import * as componentTypes from "../../../../constants/componentTypes";
import * as customActions from "../../../../actions/customTabActions";
import * as modelHelper from "../../../../helpers/modelHelper";
import * as navigationActions from "../../../../actions/navigationActions";

import CancelButton from "../../../global/generic/CancelButton";
import Button from "../../../global/generic/Button";
import Modal from "../../../global/generic/Modal";

import imgSave from "../../../../resources/img/svgicons/save.svg";

class EditNoteModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            note: this.props.params.note ?? "",
            localData: false
        };
    }

    componentDidMount = () => {
        window.jQuery("#edit-note-textarea").focus();
        if (this.props.params !== null && this.props.formula !== null) {
            this.setState({localData: this.props.formula.color.local});
        }
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseNoteModalAction();
    };

    handleSaveNoteClick = () => {
        let note = this.state.note.trim();
        if (note === "" || note === null) {
            if (this.props.params.type === "moreInfoText") {
                this.props.dispatchSetMoreInfoTextAction(this.props.tabId, null);
            } else if (this.props.params.type === "internal") {
                this.props.dispatchSaveInternalNote(this.props.tabId, null);
            } else {
                this.props.dispatchSaveNoteAction(this.props.tabId, null);
            }
        }
        if (note !== "" && note !== null) {
            if (this.props.params.type === "moreInfoText") {
                this.props.dispatchSetMoreInfoTextAction(this.props.tabId, note);
            } else if (this.props.params.type === "internal") {
                this.props.dispatchSaveInternalNote(this.props.tabId, note);
            } else {
                this.props.dispatchSaveNoteAction(this.props.tabId, note);
            }
        }
        this.props.dispatchCloseNoteModalAction();
    };

    handleEditNoteChange = (event) => {
        this.setState({note: event.target.value});
    };

    handleInputFocus = (event) => {
        event.target.select();
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <textarea
                id="edit-note-textarea"
                className="slim-scroll width-100 resize-none"
                value={this.state.note}
                onChange={this.handleEditNoteChange}
                onFocus={this.handleInputFocus}
            />
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <div className="flex text-elipsis">
                    <Button
                        className="margin-right-5"
                        svgBefore={imgSave}
                        onClick={this.handleSaveNoteClick}
                        label={<Translate value="general.save" />}
                    />
                    <CancelButton onClick={this.handleCloseModalClick} />
                </div>
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                className={this.state.localData ? "custom-formula" : ""}
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(<Translate value="mainTab.editNote" />)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{minWidth: "40%", maxWidth: "75%", minHeight: "20%", maxHeight: "50%"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (ownProps.tabId === undefined || store.formula[ownProps.tabId] === undefined) {
        return {
            formula: null
        };
    }
    return {
        formula: store.formula[ownProps.tabId].formula
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseNoteModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.EDIT_NOTE_MODAL));
        },
        dispatchSaveNoteAction: (tabId, note) => {
            dispatch(actions.saveDispenseNote(tabId, note));
        },
        dispatchSetMoreInfoTextAction: (tabId, moreInfoText) => {
            dispatch(customActions.setMoreInfoText(tabId, moreInfoText));
        },
        dispatchSaveInternalNote: (tabId, note) => {
            dispatch(actions.saveInternalNote(tabId, note));
        }
    };
};

export default EditNoteModal = connect(mapStoreToProps, mapDispatchToProps)(EditNoteModal);
